var exports = {
  "Xg": "sidebarSearch__prfJgZ",
  "ok": "sidebarSearchWrapper__T7baNI",
  "TQ": "emptySearchResultsItem__6sX3ts",
};

module.exports = exports;
